export const SENDTOLIST_SEARCH = 'SENDTOLIST_SEARCH';
export const SENDTOLIST_PAGE = 'SENDTOLIST_PAGE';